import React, { PropTypes } from 'react'
import {Col, Row, Image, Carousel, Button} from 'react-bootstrap'
import showToastr from '../../utils/showToastr'
import {map} from 'lodash'
import {Actions} from 'jumpstate'
import {Form} from 'react-form'
import {connect} from 'react-redux'
import HorseReportPhoto from './HorseReportPhoto/HorseReportPhoto'
import {MdAddAPhoto, MdUndo} from '../Common/ReactIcons/icons'
import ImageUploader from './ImageUploader'
import ImageForm from './ImageForm/ImageForm'
import PhotoLightBox from './PhotoLightBox'
import {TransitionGroup, CSSTransition} from 'react-transition-group'

import './Layout/HorsePhotos.css'

class HorsePhotos extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      currentSlide: 0,
      uploader: null,
      showImageForm: true,
      isReportBoxVisible: false,
      isShowAddPhoto: false,
      showFullScreen: false
    }
    this.reportHandler = this.reportHandler.bind(this)
  }

  componentWillMount () {
    if (this.props.photos.length > 0) {
      this.setState({isShowAddPhoto: true})
    }
  }

  reportHandler (show = true) {
    const {auth} = this.props
    if (!auth.isAuthenticated) {
      Actions.toggleLoginBox(true)
      return undefined
    }
    this.setState({isReportBoxVisible: show})
  }

  render () {
    const {photos, auth, horse} = this.props
    const {currentSlide, showImageForm, isReportBoxVisible, isShowAddPhoto, showFullScreen} = this.state
    const direction = (total, prev, index) => {
      if (prev === index) return
      if (index === 0 && (total - 1) === prev) {
        return 'next'
      }
      return prev > index ? 'prev' : 'next'
    }
    const onSlide = (index) => {

      if (index === photos.length) {
        this.setState({isShowAddPhoto: false})
      }
    }
    const showUploadPhoto = () => {
      const lastIndex = this.refs.slider.getActiveIndex()
      this.setState({isShowAddPhoto: false})
      if (photos.length === lastIndex) return
      this.refs.slider.setState({
        previousActiveIndex: lastIndex,
        direction: direction(photos.length, lastIndex, photos.length),
        activeIndex: photos.length
      })
    }
    const hideUploadPhoto = () => {
      const lastIndex = this.refs.slider.getActiveIndex()
      this.setState({isShowAddPhoto: true, currentSlide: 0})
      this.refs.slider.setState({
        previousActiveIndex: lastIndex,
        direction: direction(0, lastIndex, 0),
        activeIndex: 0
      })
    }
    return (

      <Row className="Box">
        {isReportBoxVisible && <HorseReportPhoto isVisible={isReportBoxVisible} id={photos[currentSlide].id} toggler={this.reportHandler} />}
        <Col xs={12} id="HorsePhotoBox">
          <Row id="HorsePhotoTop">
            <Col xs={12}>
              <Carousel className={!isShowAddPhoto && 'HideControl'} id="carousel-photos" ref="slider" onSelect={onSlide} touch={true} indicators controls interval={10000000000}>
                {map(photos, (photo, index) => {
                  return (
                    <Carousel.Item key={index}>
                      <Image src={photo.url.medium} onClick={() => this.setState({showFullScreen: true})} />
                    </Carousel.Item>
                  )
                })}
                <Carousel.Item key={photos.length}>
                  <div id="AddNewPhotoSlide">
                    {showImageForm && <ImageUploader ref="uploaderComponent" />}
                  </div>
                </Carousel.Item>
              </Carousel>
              {isShowAddPhoto && <div id="AddNewPhoto" onClick={showUploadPhoto}><MdAddAPhoto /></div>}
              {(!isShowAddPhoto && photos.length > 0) && <div id="CloseNewPhoto" onClick={hideUploadPhoto}><MdUndo /></div>}
            </Col>
          </Row>
          <Row id="HorsePhotoBottom">
            <Col xs={isShowAddPhoto ? 8 : 12} className="CaptionPhotos">
              {map(photos, (item, index) => {
                return (
                  <div key={index} className={currentSlide === index && isShowAddPhoto ? 'CaptionPhotosBox CaptionPhotosActive' : 'CaptionPhotosBox'}>
                    <b>{item.title}</b>
                    <br />
                    {item.description}
                    <br />
                    <Button onClick={() => this.reportHandler(true)} bsStyle="primary">گزارش عکس</Button>
                  </div>
                )
              })}
              <div key={photos.length} className={currentSlide === photos.length || !isShowAddPhoto ? 'CaptionPhotosBox CaptionPhotosActive' : 'CaptionPhotosBox'}>
                {showImageForm && <Form
                  validate={() => {
                    if (this.refs.uploaderComponent.state.isEmpty) {
                      showToastr('error', 'آپلود عکس', 'هیچ فایلی انتخاب نشده است')
                    }
                  }}
                  onSubmit={(values) => {
                    if (!auth.isAuthenticated) {
                      return Actions.toggleLoginBox(true)
                    }
                    const uploader = this.refs.uploaderComponent.state.uploader.methods
                    uploader.setForm('qq-form')
                    uploader.setCustomHeaders({
                      'Authorization': `Bearer ${auth.token}`
                    })

                    this.refs.uploaderComponent.state.uploader.on('upload', (id) => {
                      uploader.setParams({
                        ...values,
                        horse_id: horse.id,
                        file: uploader.getFile(id).name
                      }, id)
                    })
                    uploader.uploadStoredFiles()
                    this.refs.uploaderComponent.state.uploader.on('complete', () => {
                      this.setState({showImageForm: false}, () => {
                        this.setState({showImageForm: true})
                        showToastr('success', 'آپلود عکس', 'عکس مورد نظر با موفقیت آپلود شد و پس از تایید مدیر به نمایش در خواهد آمد.')
                      })
                    })
                  }}>
                  {ImageForm}
                </Form>}
              </div>
            </Col>
            {isShowAddPhoto && <Col xs={4} >
              <Row className="imageSmallBox">
                {map(photos, (photo, index) => {
                  return (
                    <Col xs={6} sm={6} md={4} key={index} >
                      <Image src={photo.url.thumb} width={40} onClick={() => {
                        const lastIndex = this.refs.slider.getActiveIndex()
                        if (lastIndex !== index) {
                          this.refs.slider.setState({
                            previousActiveIndex: lastIndex,
                            direction: direction(photos.length, lastIndex, index),
                            activeIndex: index
                          })
                        }
                      }} />
                    </Col>
                  )
                })}
              </Row>
            </Col>
          }
            {this.refs.slider && <TransitionGroup enter appear exit>
              {showFullScreen && <CSSTransition classNames="sl-fade" timeout={1000} in={showFullScreen} mountOnEnter unmountOnExit>
                <PhotoLightBox
                  hider={() => this.setState({showFullScreen: false})}
                  photos={photos}
                  currentPhoto={this.refs.slider.getActiveIndex()}
                />
              </CSSTransition>}
            </TransitionGroup>}
          </Row>
        </Col>
      </Row>
    )
  }
}

HorsePhotos.propTypes = {
  photos: PropTypes.array.isRequired,
  horse: PropTypes.object.isRequired
}

const mapStateToProps = (state) => {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps)(HorsePhotos)



// WEBPACK FOOTER //
// ./src/components/HorseInfo/HorsePhotos.js